import type { CertificationLevel } from '../../../../../index';
import getHelper from '../../../services/getHelper';

export default getHelper<CertificationLevel>('/certification-levels/:id');
